module.exports = __webpack_public_path__ + "img/QQ.3dfa73d2.png";